import gql from 'graphql-tag';

export const add = gql`mutation CreateInvoice($invoice: InvoiceInput!) {
    createInvoice(invoice: $invoice) {
        id
        label
        amount
        documentType
    }
}`;


export const edit = gql`mutation EditInvoice($id: ID!, $invoice: InvoiceInput!) {
    editInvoice(id: $id, invoice: $invoice) {
        id
        label
        amount
        documentType
    }
}`;

export const remove = gql`mutation RemoveInvoice($id: ID!) {
    removeInvoice(id: $id) {
        id
        label
        amount
        documentType
    }
}`;


// WEBPACK FOOTER //
// ./src/graphql/mutations/invoice.js